import { render, staticRenderFns } from "./Jteacher.vue?vue&type=template&id=d5c8fd8c&scoped=true"
import script from "./Jteacher.vue?vue&type=script&lang=js"
export * from "./Jteacher.vue?vue&type=script&lang=js"
import style0 from "./Jteacher.vue?vue&type=style&index=0&id=d5c8fd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c8fd8c",
  null
  
)

export default component.exports